

export const numFormat = new Intl.NumberFormat();
export const bodyNumber = (row: any, config: any) => {
    return numFormat.format(row[config.field]);
}
